module.exports = __webpack_public_path__ + "static/media/icon-event__conflicto-en-los-balcanes-hover.83efd0bb.svg";